import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import Card from '../../card/card';
import cloneDeep from 'lodash/cloneDeep';
import FCSlider from '../../fc_slider/fc_slider';
import Ad from '../../ad/ad';
import generateTagData from '../../../../utils/advertorial_utils';
import { isAdvertorial } from '../../../../views/components/advertorial/advertorial';
import Drawer from '../../../../views/components/drawer/drawer';
import log from '../../../../services/logger_service';
import Cookies from 'js-cookie';
import MobileVideoPlayer from '../../mobile_video_module/mobile_video_module_reactjw';
import Sticky from 'react-stickynode';
import { trackGAEvent } from '../../../../client/utils/third_party_trackers/ga';
import AccordionGallery from '../../accordion_gallery/accordion_gallery';
import { UserConsumer } from '../../../components/context/userContext';

/* eslint no-nested-ternary: 0 */

class Article extends Component {
  constructor() {
    super();
    this.state = {
      midArticleInjection: null,
      alwaysOn: null,
      hideMobileVideoPlayer: false,
      showGlobalPlayer: false,
      drawerFilled: false
    };

    this.renderNativeAlwaysOn = this.renderNativeAlwaysOn.bind(this);
    this.hideMobileVideoPlayer = this.hideMobileVideoPlayer.bind(this);
    this.drawerHasFilled = this.drawerHasFilled.bind(this);

    this.isMobile = false;
    this.showPlayer = false; // Remove once debugged.
    this.showDesktopBillboard = true; // Hard/static display boolean for ad purposes
    this.showLiveBanner = false;

    this.drawerRef = React.createRef();
    this.parsLoaded = 0;
  }

  componentDidMount() {
    this.checkWindowSize();
    // window.addEventListener('resize', this.checkWindowSize.bind(this));
  }

  componentWillReceiveProps(nextProps) {
    if (isAdvertorial(get(nextProps, 'post.tags'))) {
      return;
    }

    if (
      !this.state.midArticleInjection &&
      get(nextProps, 'postNativeAd.length')
    ) {
      const modifiedInjectionArticle = get(nextProps, 'postNativeAd[0]');
      const advertiserData = generateTagData(
        get(modifiedInjectionArticle, 'tags')
      );

      modifiedInjectionArticle.customEyebrowText = get(
        advertiserData,
        'advertiser'
      );

      this.setState({
        midArticleInjection: [modifiedInjectionArticle]
      });
    }
  }

  setPostChunk(
    chunkOriginal,
    index,
    totalChunkLength,
    id,
    meter,
    isActiveSubscriber
  ) {
    const chunk = [...chunkOriginal];
    const self = this;
    const { post, advertorial } = this.props;
    const chunks = get(post, 'content', []);
    const paywallViewLimit = 3; // SHOULD BE DYNAMIC FROM JOURNEY ULTIMATELY!!!
    const viewsLeft = get(meter, 'viewsLeft', 100);
    let chunkingStopped = get(this, 'chunkingStopped', false);
    let currentParCount = get(this, 'parsLoaded', 0);
    const podcastEmbedIndex = get(post, 'categories', []).findIndex(
      category => typeof category.podcastEmbed !== 'undefined'
    );

    if (index === Math.floor(totalChunkLength / 3)) {
      const podcastChunk = get(
        post,
        `categories[${podcastEmbedIndex}].podcastEmbed`,
        ''
      );

      // chunk.splice(podcastChunk);
      chunk.push(podcastChunk);
    }

    // Resetting paragraph counter and chunking flag between renders
    if (index === 0) {
      currentParCount = 0;
      this.chunkingStopped = false;
      chunkingStopped = false;
    }
    const paywallLimitReached =
      viewsLeft <= 0 && chunk.length + currentParCount > paywallViewLimit;

    if (chunkingStopped && !advertorial) {
      return null;
    }

    // Strip paragtraphs that go over paywall limit
    if (
      paywallLimitReached &&
      !advertorial &&
      !isActiveSubscriber &&
      this.state.drawerFilled
    ) {
      const toRemove = chunk.length + currentParCount - paywallViewLimit - 1;
      chunk.splice(chunk.length - toRemove, toRemove);
      this.chunkingStopped = true;
    } else {
      this.parsLoaded = currentParCount + chunk.length;
    }

    const midArticleInjection =
      this.state.midArticleInjection &&
      index === Math.floor(totalChunkLength / 2)
        ? this.state.midArticleInjection.map(article => (
            <div
              className="native-injection"
              key={`native-injection-${article.id}`}
            >
              <Card
                config={this.props.config}
                type="injection"
                metadata={article}
                key={article.id}
                cardEvent={() => {
                  trackGAEvent({
                    eventCategory: 'Engagement',
                    eventAction: 'nativeMidArticleInjection',
                    eventLabel: get(article, 'title')
                  });
                }}
              />
            </div>
          ))
        : '';

    const alwaysOnInjection =
      this.state.alwaysOn && index === Math.floor(totalChunkLength / 2)
        ? this.state.alwaysOn
        : '';

    let midPosition = Math.ceil(chunk.length / 2);
    const preventWithOtherInjections = false;

    // Handles if the chunk contains a header, we dont want to insert it right after the header
    if (
      chunk[midPosition - 1] &&
      (chunk[midPosition - 1].includes('<h2>') ||
        chunk[midPosition - 1].includes('<h3>'))
    ) {
      midPosition = Math.floor(chunk.length / 2 + 1);
    }

    if (
      // this.showPlayer === true && // Un-comment this line disable entirely!
      this.props.pageNum === 0 &&
      index === 0 &&
      this.isMobile &&
      // !Cookies.get('fc_rev_content') &&
      !Cookies.get('hideMobileVideoPlayer') &&
      !this.state.hideMobileVideoPlayer
    ) {
      const markupFirstHalf = [...chunk.slice(0, 1)].join('');
      const markupSecondHalf = [...chunk.slice(1, chunk.length)].join('');

      if (
        chunks.join('').indexOf('video-wrapper') !== -1 &&
        preventWithOtherInjections
      ) {
        return (
          // RETURN WITHOUT MOBILE VIDEO INSERT IF THERE IS A VIDEO IN THE ARTICLE
          <Fragment key={`chunk-${index}`}>
            <div dangerouslySetInnerHTML={{ __html: markupFirstHalf }} />
            {this.state.showGlobalPlayer !== null && (
              <div>{this.state.showGlobalPlayer}</div>
            )}
            <div dangerouslySetInnerHTML={{ __html: markupSecondHalf }} />
          </Fragment>
        );
      }

      return (
        // return WITH mobile video insert because there is no video in the article...
        // we just dont want a video ad to appear if there is a video in the article already
        <Fragment key={`chunk-${index}`}>
          <div dangerouslySetInnerHTML={{ __html: markupFirstHalf }} />
          {this.state.showGlobalPlayer == null && (
            <div className="mobile-sticky-player">
              <Sticky innerZ="10000000">
                <MobileVideoPlayer
                  mobileInline={true}
                  type="rightrail"
                  playerid="delVxmba"
                  // hard coded playlist for alison/jonelle
                  playlistId="mPuU1BDa"
                  pos="newmultiplayer"
                  hideMobileVideoPlayer={self.hideMobileVideoPlayer}
                />
              </Sticky>
            </div>
          )}
          <div dangerouslySetInnerHTML={{ __html: markupSecondHalf }} />
        </Fragment>
      );
    }

    const markupFirstHalf = [...chunk.slice(0, midPosition)].join('');
    const markupSecondHalf = [...chunk.slice(midPosition, chunk.length)].join(
      ''
    );

    if (
      markupFirstHalf === 'INLINE_CAROUSEL' ||
      markupFirstHalf === 'INLINE_CAROUSEL'
    ) {
      return (
        <FCSlider
          key={`inline-slideshow-${id}-${index}`}
          slideShowData={this.inlineCarousels.shift()}
          location="post__inline"
        />
      );
    }

    // just return whole chunk if there's no article injection
    if (midArticleInjection === '' && this.state.alwaysOn == null) {
      return (
        <Fragment key={`chunk-${index}`}>
          <div dangerouslySetInnerHTML={{ __html: chunk.join('') }} />
        </Fragment>
      );
    }

    if (midArticleInjection && alwaysOnInjection) {
      const choice = Math.floor(Math.random() * 2);
      const nativeArray = [midArticleInjection, alwaysOnInjection];

      return (
        <Fragment key={`chunk-${index}`}>
          <div dangerouslySetInnerHTML={{ __html: markupFirstHalf }} />
          {nativeArray[choice]}
          <div dangerouslySetInnerHTML={{ __html: markupSecondHalf }} />
        </Fragment>
      );
    }

    if (midArticleInjection) {
      return (
        <Fragment key={`chunk-${index}`}>
          <div dangerouslySetInnerHTML={{ __html: markupFirstHalf }} />
          {midArticleInjection}
          <div dangerouslySetInnerHTML={{ __html: markupSecondHalf }} />
        </Fragment>
      );
    }

    if (alwaysOnInjection) {
      return (
        <Fragment key={`chunk-${index}`}>
          <div dangerouslySetInnerHTML={{ __html: markupFirstHalf }} />
          {alwaysOnInjection}
          <div dangerouslySetInnerHTML={{ __html: markupSecondHalf }} />
        </Fragment>
      );
    }

    return (
      <Fragment key={`chunk-${index}`}>
        <div dangerouslySetInnerHTML={{ __html: chunk.join('') }} />
      </Fragment>
    );
  }

  setMobileAdName(index) {
    // console.log('given index', index)
    let adName;

    if (index === 0) {
      adName = 'mobileparallax_1';
      // console.log('case 1', adName)
      return adName;
    }

    if (index === 3) {
      adName = 'mobileparallax_2';
      // console.log('case 2', adName)
      return adName;
    }

    adName = `mobilerectangle_${index}`;
    this.mobileAdIndex += 1;

    // console.log('case 3', adName)
    return adName;
  }

  checkWindowSize() {
    this.isMobile = window.innerWidth < 1024;
    this.forceUpdate();
  }

  hideMobileVideoPlayer() {
    /* eslint-disable-next-line func-names */
    this.setState({ hideMobileVideoPlayer: true }, function() {
      Cookies.set('hideMobileVideoPlayer', true, { expires: 1 });
      this.forceUpdate();
    });
  }

  notAroundCarousel(chunks, currentChunk, index) {
    const next = chunks[index + 1] || [];
    const nextZeroIndex = next[0];
    const carousel = 'INLINE_CAROUSEL';

    if (nextZeroIndex === carousel || currentChunk === carousel) {
      return false;
    }

    return true;
  }

  drawerHasFilled() {
    this.setState({
      drawerFilled: true
    });
  }

  renderNativeAlwaysOn(response, index) {
    const alwaysOn = (
      <a href={response.clickthrough_url} target="_blank">
        <div
          style={{
            backgroundImage: `url(${response.bg_image})`,
            height: '180px',
            width: '100%',
            backgroundSize: 'contain',
            margin: '20px auto',
            textAlign: 'center',
            backgroundRepeat: 'no-repeat'
          }}
          className={`alwaysOn_${index}`}
        />
      </a>
    );
    this.setState({ alwaysOn }, () => {
      // console.log('this.state.alwaysOn', this.state.alwaysOn);
    });
  }

  render() {
    const {
      config,
      post,
      pageNum,
      combinedAdModel,
      isShortPost,
      advertorial
    } = this.props;

    const thePostId = get(post, 'id', 'unknown-post-id');
    const self = this;
    // CHECK FOR RECOMMENDER ADZONE TO SEE IF THIS IS RECOMMENDER ARTICLE:
    const recommender =
      combinedAdModel.model.adzone.indexOf('recommender') !== -1;
    // Check if this is a recommender article and device type is mobile:
    let recommenderMobile = false;

    if (recommender && this.isMobile) {
      recommenderMobile = true;
    }

    const masonryCollection = get(post, 'customFields.masonry_collection', []);

    const chunks = get(post, 'content', []);
    if (!chunks.length) {
      log.error(
        'No article chunk found, this article has no body content: ',
        get(post, 'link')
      );
    }

    this.mobileAdIndex = 1;
    this.inlineCarousels = cloneDeep(get(post, 'inlineCarousels')) || [];
    const nativePixelContentArticlePageFeatureFlag = get(
      config,
      'featureFlags.nativePixelContentArticlePage'
    );

    const nativeAdPixel = nativePixelContentArticlePageFeatureFlag ? (
      <div>
        <Ad
          {...combinedAdModel}
          pos="atf"
          noBorder={true}
          slug={false}
          name="native_infinitescroll"
          noLazyLoad={true}
        />
        <Ad
          {...combinedAdModel}
          pos="atf"
          noBorder={true}
          slug={false}
          name="native_recommendationlink"
          broadcastAdsLoaded={true}
          noLazyLoad={true}
        />
        <Ad
          {...combinedAdModel}
          pos="atf"
          noBorder={true}
          slug={false}
          name="native_sponsoredtile"
          noLazyLoad={true}
        />
        <Ad
          {...combinedAdModel}
          pos="atf"
          noBorder={true}
          slug={false}
          name="native_second"
          noLazyLoad={false}
        />
      </div>
    ) : (
      ''
    );

    if (post.isVideoPermalink) {
      return (
        <article className="post__article">
          <p>{post.excerpt}</p>
        </article>
      );
    }

    if (advertorial) {
      for (let i = 0; i < chunks.length; i += 1) {
        for (let j = 0; j < chunks[i].length; j += 1) {
          const regex = /<a[^>]*/gm;
          let matches;

          // eslint-disable-next-line
          while ((matches = regex.exec(chunks[i][j])) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (matches.index === regex.lastIndex) {
              regex.lastIndex += 1;
            }
            // eslint-disable-next-line no-loop-func
            matches.forEach(match => {
              chunks[i][j] = chunks[i][j].replace(
                match,
                `${match} rel="nofollow"`
              );
            });
          }
        }
      }
    }

    return (
      <UserConsumer>
        {({ meter, isActiveSubscriber }) => {
          const shouldPopDrawer = get(meter, 'viewsLeft', 100) <= 0;
          const exceptions = new RegExp(
            // eslint-disable-next-line no-useless-escape
            /<h2|<h3|<ul|<ol|<strong|<blockquote|<iframe|<img|class=\"pullquote/,
            'gi'
          );
          // Dont show mid article inject if any of the tags above ^ are beside it:
          if (
            Array.isArray(get(chunks, '[2]')) &&
            Array.isArray(get(chunks, '[1]')) &&
            (exceptions.test(chunks[2][0]) ||
              exceptions.test(chunks[1][chunks[1].length - 1]))
          ) {
            this.showDesktopBillboard = false;
          }
          return (
            <article
              className={`post__article ${
                shouldPopDrawer ? 'post__article--drawerpop' : ''
              } ${advertorial ? 'post__article--advertorial' : ''}`}
            >
              {this.showLiveBanner && (
                <div className="fcf-live-banner">
                  <a href="https://events.fastcompany.com/innovationfestival21/keynote-pass">
                    Watch the Fast Company Innovation Festival Live now.
                  </a>
                </div>
              )}
              {chunks.map((chunk, index) => [
                this.setPostChunk(
                  chunk,
                  index,
                  chunks.length,
                  post.id,
                  meter,
                  isActiveSubscriber
                ),
                this.showDesktopBillboard && index === 1 ? (
                  <div className="articleForceInjection">
                    <Ad
                      name="mid_article_inject"
                      noBorder={true}
                      {...combinedAdModel}
                    />
                  </div>
                ) : null,
                !isShortPost && index < chunks.length - 1 ? (
                  this.notAroundCarousel(chunks, chunk[0], index) ? (
                    !recommenderMobile ? ( // if the article is not a recommender article, serve ads on mobile...
                      <div key={`recommenderMobileA-${index}-for-${thePostId}`}>
                        {index === 0 ? (
                          <div id="fc-anyclip">
                            <Ad
                              key={`chunk-ad-${index}`}
                              {...combinedAdModel}
                              pos="btf"
                              pageNum={pageNum}
                              name={this.setMobileAdName(index)}
                              onSlotRenderEnded={slotEvent => {
                                if (slotEvent.size.indexOf(640) === -1) {
                                  // If there is not a parallax ad, show the mobile sticky player.. (null will show it, false will hide):
                                  self.setState({ showGlobalPlayer: null });
                                }
                              }}
                            />
                          </div>
                        ) : (
                          <Ad
                            key={`chunk-ad-${index}`}
                            {...combinedAdModel}
                            pos="btf"
                            pageNum={pageNum}
                            name={this.setMobileAdName(index)}
                          />
                        )}
                      </div>
                    ) : (
                      <div key={`recommenderMobileB-${index}-for-${thePostId}`}>
                        {index === Math.floor(chunks.length / 2) ? ( // ... otherwise serve only 1 ad on recommender articles
                          <Ad
                            key={`chunk-ad-${index}`}
                            {...combinedAdModel}
                            pos="btf"
                            pageNum={pageNum}
                            name={this.setMobileAdName(index)}
                          />
                        ) : null}
                      </div>
                    )
                  ) : null
                ) : null,
                nativePixelContentArticlePageFeatureFlag &&
                  get(post, 'totalParagraphs') >= 7 &&
                  !advertorial &&
                  index === 0 && (
                    <div
                      key={`native-mid-article-inject-${index}-for-${thePostId}`}
                      className={`adInserts_${index}`}
                    >
                      <Ad
                        key={`native-ad-${index}`}
                        {...combinedAdModel}
                        pos="btf"
                        noBorder={true}
                        slug={false}
                        name="native_mid_article_inject"
                        callback={response => {
                          if (response.native_type === 'AlwaysOn') {
                            this.renderNativeAlwaysOn(response, index);
                          }
                        }}
                      />
                      <Ad
                        key={`oop-ad-${index}`}
                        {...combinedAdModel}
                        pos="atf"
                        noBorder={true}
                        slug={false}
                        oop={true}
                        name="oop"
                        callback={() => {
                          // console.log('display', response);
                        }}
                      />
                    </div>
                  )
              ])}
              {masonryCollection &&
                masonryCollection.map((data, index) => (
                  <AccordionGallery
                    key={`AccordionGallery-${index}`}
                    {...data}
                  />
                ))}
              {!advertorial && (
                <Drawer
                  pageNum={get(post, 'id', 'NI')}
                  drawerRef={this.drawerRef}
                  onDrawerFilled={this.drawerHasFilled}
                />
              )}
              {nativeAdPixel}
              <div
                id="collapsible-placeholder"
                style={{
                  width: '100%',
                  position: 'fixed',
                  bottom: '0',
                  left: '0',
                  zIndex: '9999',
                  backgroundColor: '#FFFFFF'
                }}
              />
            </article>
          );
        }}
      </UserConsumer>
    );
  }
}

Article.propTypes = {
  advertorial: PropTypes.bool.isRequired,
  post: PropTypes.shape({}).isRequired,
  combinedAdModel: PropTypes.shape({}).isRequired,
  pageNum: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  config: PropTypes.shape({}).isRequired,
  isShortPost: PropTypes.bool.isRequired
};

function mapStateToProps(state = {}) {
  const nativeAdInjectData = get(
    state,
    'postNativeAd.data.midArticleInject.posts'
  );

  if (nativeAdInjectData) {
    return {
      postNativeAd: nativeAdInjectData
    };
  }

  return {
    postNativeAd: []
  };
}

export default connect(mapStateToProps)(Article);
